import { User } from 'entities/User/types';

export enum CoUserStatusEnum {
	active = 'ACTIVE',
	invited = 'INVITED',
	api_only = 'API_ONLY',
}

export type FileAccessType = 'OWN' | 'ALL' | 'SELECTED';

export enum ESectionAccessLevel {
	NO_ACCESS = 'NO_ACCESS', // default — no access to the section
	VIEW_ONLY = 'VIEW_ONLY', // read-only list access
	FULL_ACCESS = 'FULL_ACCESS', // full access (invite, delete, edit)
}

export interface CoUserPermissions {
	fileAccessType?: FileAccessType;
	accessibleUserIds?: string[];
	coUsers?: ESectionAccessLevel;
}

export interface UpdateCoUserPermissionsPayload {
	fileAccessType?: FileAccessType;
	accessibleUserIds?: string[];
	coUsers?: ESectionAccessLevel;
}

export type CoUser = {
	_id: string;
	invitedBy: Pick<User, '_id' | 'firstName' | 'lastName'>;
	email?: string;
	status?: CoUserStatusEnum;
	userId?: Pick<User, '_id' | 'email' | 'firstName' | 'lastName'>;
	joinedAt: string;
	createdAt: string;
	filesCounter: 0;
	companyName: string;
	dealerName: string;
	totalPages: 0;
	permissions?: CoUserPermissions;
};
